import HttpClient from "./HttpClient";

export default class StatusRight{
    constructor(statusRight){
        this.id = statusRight.id;
        this.user_type = statusRight.user_type;
        this.before = statusRight.before;
        this.after = statusRight.after;
        this.title = statusRight.title;
        this.company_id = statusRight.company_id;
        this.created_at = statusRight.created_at;
        this.updated_at = statusRight.updated_at;
        this.table_name = statusRight.table_name;
    }

    static async loadStatusRights(){
        const client = new HttpClient();
        const response = await client.instance.get("status-rights");
        return response.data;
    }
}